module.exports = __webpack_public_path__ + "img/portfolio-05-670x479.55ebd30c.jpg";